module.exports = __webpack_public_path__ + "img/help.b7ae8820.svg";